import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import * as Rx from 'rxjs/Rx';
import { API } from '../_config/strings';

@Injectable()
export class WebsocketService {

  // Our socket connection
  private socket;
  public API;

  constructor() {
    this.API = API;
   }

  connect(room): Rx.Subject<MessageEvent> {
    // If you aren't familiar with environment variables then
    // you can hard code `environment.ws_url` as `http://localhost:5000`
    // Desarrollo:
    this.socket = io(this.API.notificaciones);
    // Producción:
    // this.socket = io('http://sm8-betasoft.ddns.net:5000');

    this.socket.emit('create', room);
    // console.log(room);
    // We define our observable which will observe any incoming messages
    // from our socket.io server.
    let observable = new Observable(observer => {
        this.socket.on('getRooms', () => {
          observer.next();
        });
        this.socket.on('message', (data) => {
         // console.log("Received message from Websocket Server")
          observer.next(data);
        })
        return () => {
          this.socket.disconnect();
        }
    });

    // We define our Observer which will listen to messages
    // from our other components and send messages back to our
    // socket server whenever the `next()` method is called.
    let observer = {
        next: (data: Object) => {
       //  console.log(data['tipo']);
       if(data['tipo'] === 'chat' || data['tipo'] === 'notificacion' || data['tipo'] === 'visto' || data['tipo'] === 'escribiendo')
       {
        this.socket.emit('message', data);
       }
       else {
          this.socket.emit('getRooms');
       }
      },
    };

    // we return our Rx.Subject which is a combination
    // of both an observer and observable.
    return Rx.Subject.create(observer, observable);
  }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_services/websocket.service.ts